// Welle 131 — gemeinsame Helfer für die Rename-me-Stammdaten in DB 2
import { API_BASE } from "../../api/config";

export const SD_API = `${API_BASE}/database/rename-stammdaten`;

export async function sdJson(url, opts) {
  const r = await fetch(url, opts);
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || `HTTP ${r.status}`);
  return d;
}
export const sdPost = (pfad, body) => sdJson(`${SD_API}${pfad}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
export const sdPut = (pfad, body) => sdJson(`${SD_API}${pfad}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });

// Kategorie ↔ DB-2-Tabelle ↔ STRG-Kategorie
export const KATS = [
  { kat: "vertraege", titel: "Vertrag", strg: "vertrag", tabelle: "vertraege" },
  { kat: "versicherungen", titel: "Versicherung", strg: "versicherung", tabelle: "versicherungen" },
  { kat: "iban", titel: "Bank / IBAN", strg: "iban", tabelle: "banken" },
  { kat: "steuernummer", titel: "Steuernummer", strg: "steuernummer", tabelle: "steuernr" },
  { kat: "darlehen", titel: "Darlehen", strg: "darlehen", tabelle: "darlehen" },
  { kat: "mietvertraege", titel: "Mietvertrag", strg: "mietvertrag", tabelle: "mietvertraege" },
];
export const KAT_AUS_TABELLE = Object.fromEntries(KATS.map((k) => [k.tabelle, k.kat]));
export const KAT_AUS_STRG = Object.fromEntries(KATS.map((k) => [k.strg, k.kat]));

export const LABEL = {
  objektid: "Objekt/Einheit", art: "Art", lieferant: "Lieferant", vertagspartner: "Vertragspartner (wir)",
  vertragid: "Vertrags-ID", vetragsnummer: "Vertragsnummer", vertrgskonto: "Vertragskonto", kundennummer: "Kundennummer",
  zaehlernummer: "Zählernummer", marktlocation: "Marktlokation", vertrags_beginn: "Beginn", vertrags_ende: "Ende",
  x_gekuendigt: "gekündigt (x)", rename_praefix: "Präfix (Rename-me)", rename_absender: "Absender (Rename-me)",
  rename_schema: "Schema (Rename-me)", index: "Index", gesellschaft: "Gesellschaft", vers_nr: "Versicherungsnr.",
  objektnr: "Objekt", nr: "Inhaber", objektname: "Objektname", beginn: "Beginn", ablauf: "Ablauf",
  suchbegriff: "Suchbegriff", bank_name: "Bank", iban: "IBAN / Kartennr.", bic: "BIC", konto_inhaber: "Inhaber",
  bank_kurzname: "Kurzname", genutzt_fuer: "genutzt für", geschlossen_am: "geschlossen am", name: "Name",
  steuernr: "Steuernummer", finanzamt: "Finanzamt", bufa_nr: "BUFA", ust_id: "USt-IdNr.", id_nr: "Steuer-ID",
  alt_steuernr: "alte Steuernr.", darlehenid: "Darlehen-ID", verwendung: "Verwendung", darlehens_nr: "Darlehensnr.",
  alte_darlehens_nr: "alte Darlehensnr.", darlehensgeber: "Darlehensgeber", darlehensnehmer: "Darlehensnehmer",
  darlehens_betrag: "Betrag", mietvertragnr: "Mietvertrag", mietvertrag_kurzname: "Mieter", mieter1nr: "Mieter-Nr.",
  mieter1name: "Mietername", mietvertrag_beginn: "Beginn", mietvertrag_ende: "Ende", bank_kuerzel: "Bankkürzel (DKB, HSP …)",
  zielpfad: "Zielpfad",
};
export const wirksamText = (w) => !w ? "" : [w.praefix && `Präfix ${w.praefix}`, w.absender && `Absender ${w.absender}`,
  w.vnr5 && `VNR5 ${w.vnr5}`, w.vers5 && `VERS5 ${w.vers5}`, w.bank && `Bank ${w.bank}`, w.aktiv === false && "gekündigt", w.zielpfad && `Ziel ${w.zielpfad}`].filter(Boolean).join(" · ");
